import { serverResponse } from 'app'

import * as actions from '../../actions/players'

export const getPlayersInitialState = () => serverResponse()

export default (state = getPlayersInitialState(), action = {}) => {
  switch (action.type) {
    case actions.TRN_PLAYERS_FETCH: {
      return {
        ...state,
        key: action.payload,
        loaded: false,
        loading: true,
      }
    }

    case actions.TRN_PLAYERS_FETCH_CANCELED: {
      return {
        ...state,
        key: null,
        loaded: false,
        loading: false,
      }
    }
    case actions.TRN_PLAYERS_FETCH_ERROR: {
      return {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      }
    }
    case actions.TRN_PLAYERS_FETCH_FULFILLED: {
      return {
        ...state,
        ...action.payload,
        loaded: true,
        loading: false,
      }
    }
    case actions.TRN_PLAYERS_RESET: {
      return getPlayersInitialState()
    }
    default:
  }
  return state
}
